import { MGPOptional, Utils } from '@everyboard/lib';
export class MartianChessPiece {
    value;
    static EMPTY = new MartianChessPiece(0);
    static PAWN = new MartianChessPiece(1);
    static DRONE = new MartianChessPiece(2);
    static QUEEN = new MartianChessPiece(3);
    static tryMerge(left, right) {
        const noEmptyPieces = left !== MartianChessPiece.EMPTY && right !== MartianChessPiece.EMPTY;
        Utils.assert(noEmptyPieces, 'tryMerge cannot be called with empty pieces');
        const totalValue = left.value + right.value;
        if (totalValue === 2 || totalValue === 3) {
            return MGPOptional.of(MartianChessPiece.of(totalValue));
        }
        else {
            return MGPOptional.empty();
        }
    }
    static of(value) {
        switch (value) {
            case MartianChessPiece.DRONE.value: return MartianChessPiece.DRONE;
            default:
                Utils.expectToBe(value, MartianChessPiece.QUEEN.value);
                return MartianChessPiece.QUEEN;
        }
    }
    constructor(value) {
        this.value = value;
    }
    getValue() {
        return this.value;
    }
    equals(other) {
        return this.getValue() === other.getValue();
    }
}
